exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .ButtonRole_container__2HSW-{cursor:pointer}[dir] .ButtonRole_container__2HSW-.ButtonRole_disabled__DwRw1{cursor:not-allowed}", ""]);

// Exports
exports.locals = {
	"container": "ButtonRole_container__2HSW-",
	"disabled": "ButtonRole_disabled__DwRw1"
};